import { motion } from "framer-motion";
import { EASE } from "../lib/site";

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, id }) => (
  <div className="max-w-3xl">
    <Reveal><p className="eyebrow" data-testid={`${id}-eyebrow`}>{eyebrow}</p></Reveal>
    <Reveal delay={0.08}>
      <h2 className="f-display mt-6 text-3xl sm:text-4xl lg:text-5xl leading-[1.12] text-[var(--paper)]" data-testid={`${id}-title`}>{title}</h2>
    </Reveal>
  </div>
);
